/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class SettlementControllerDtoListSettlementType.
* @enum {}
* @readonly
*/
export default class SettlementControllerDtoListSettlementType {
    
        /**
         * value: 0
         * @const
         */
        "0" = 0;

    

    /**
    * Returns a <code>SettlementControllerDtoListSettlementType</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/SettlementControllerDtoListSettlementType} The enum <code>SettlementControllerDtoListSettlementType</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

